import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ttf2rmvq3s: FaireBrandEntity = {
  token: "b_ttf2rmvq3s",
  type: "brand",
  name: "From Rosalie",
  avatarUrl:
    "https://cdn.faire.com/fastly/967d77d235c923dc7af421b9dffcaaae7f46a63139d31d3e8cf6910e5f38d539.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/20246b6f2e56f51152daa1b483d668db7fbe9172797ea0acd2bb1c50e1ca8518.png",
  logoUrl:
    "https://cdn.faire.com/fastly/967d77d235c923dc7af421b9dffcaaae7f46a63139d31d3e8cf6910e5f38d539.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/20246b6f2e56f51152daa1b483d668db7fbe9172797ea0acd2bb1c50e1ca8518.png",
  location: "Sydney, AUS",
  minimumOrderDollars: 66,
  rating: 5,
  reviewCount: 11,
  isTopShop: true,
  isInsider: false,
  description:
    "ABOUT THE BRAND:\n\nFrom Rosalie is an independent Australian brand creating cheerful, design-led greeting cards and heartfelt children’s books. Each piece is thoughtfully illustrated to feel bold, playful, and a little bit special…the kind of designs people pick up, smile at, and don’t want to put back down.\nAll products are created slowly and intentionally, printed in small batches (never mass-made), with a strong focus on quality materials and meaningful design. From Rosalie is known for vibrant colour, cheeky humour, and non-seasonal wording - making the range easy to stock and loved all year round.\n\nABOUT THE MAKER:\n\nFrom Rosalie is created by Rosalie Shaw, an author, illustrator, certified pun enthusiast, and flight attendant. Balancing life between the skies and the studio, many designs begin mid-flight or on the go, inspired by small moments, fleeting ideas, and the occasional unhinged thought.\nAll illustrations are digitally hand-drawn by Rosalie in her Sydney studio (or wherever she happens to be), then printed on eco-friendly recycled paper. Every design is crafted to spark joy, stir hearts, and occasionally cause a happy tear or two.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:56.641Z",
    importedBy: "entity-db-cli",
  },
};
